module.exports = __webpack_public_path__ + "static/media/nl_qr.0a821387.jpg";